<!--
    Program: CodeMgmt.vue
    Author: SDL
    Description: Code Management
    Created: 2020.03.13
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">Mobile Code Management</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->
            <div v-if="mode === 'search'">
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w49">
                                <li class="tit_150">Code Category</li>
                                <li data-input-type="select" class="w100-150">
                                    <select
                                        class="slt_white w100p"
                                        v-model="selectedCodeId"
                                        @change="selectCodeId"
                                    >
                                        <option
                                            v-for="item in availableParentCodeList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w49">
                                <li class="tit_150">Code Name</li>
                                <li data-input-type="input" class="w100-150">
                                    <input
                                        type="text"
                                        class="text_input w100"
                                        v-model="codeName"
                                        v-clearable
                                    />
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR">
                            <span class="btn">
                                <a href="javascript:" class="btn_srch" @click="search(1)">Search</a>
                            </span>
                        </div>
                    </article>
                </div>
                <div>
                    <!-- Grid -->
                    <div class="grid_wrap">
                        <!-- Grid Count-->
                        <div class="grid_total">
                            Total Count
                            <em>{{ resultCount | numberFormat }}</em>
                        </div>
                        <!-- Grid "btn-->
                        <div class="btn_wrap">
                            <a
                                href="javascript:"
                                class="btn_gray"
                                @click="switchMode('create')"
                            >Create</a>
                            <a
                                href="javascript:"
                                class="btn_white"
                                @click="excelDownload()"
                            >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                        </div>
                        <div id="grid">
                            <toast-grid
                                gridId="gridFindContent"
                                :key="gridKey"
                                :data="gridData"
                                :columns="gridColumns"
                                :options="gridOptions"
                                :pageOptions="gridPageOptions"
                                :theme="gridTheme"
                                :isTotalCount="false"
                                v-bind:click="gridItemClick"
                            />
                        </div>
                    </div>
                    <div class="paginate">
                        <sdl-pagination
                            :current-page="currentPage"
                            :total-rows="resultCount"
                            :per-page="perPage"
                            @change="search"
                            align="center"
                        />
                    </div>
                </div>
            </div>
            <div v-else-if="mode === 'create'">
                <code-mgmt-item
                    mode="create"
                    v-on:back="switchMode('search')"
                    v-on:create="search(1)"
                    :codeIdxList="availableParentCodeList"
                />
                <!-- <div class="btn_left" style="margin-top: -32px; z-index: 1000;">
                <a href="javascript:" class="btn_white" @click="switchMode('search')">List</a>
                </div>-->
            </div>
            <div v-else-if="mode === 'edit'">
                <code-mgmt-item
                    mode="edit"
                    v-on:back="switchMode('search')"
                    v-on:save="search(currentPage)"
                    v-on:delete="search(1)"
                    :codeIdxList="availableParentCodeList"
                    :codeIdx="gridData[selectedGridDataKey].CODE_PARENT_ID"
                    :codeId="gridData[selectedGridDataKey].CODE_ID"
                    :codeName="gridData[selectedGridDataKey].CODE_NAME"
                    :codeNote="gridData[selectedGridDataKey].CODE_NOTE"
                />
                <div class="btn_left" style="margin-top: -32px;">
                    <a href="javascript:" class="btn_white" @click="switchMode('search')">List</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';

import { SDLUtil, StringUtil, DateUtil } from '@/utils';
import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import ExcelDownloadPopup from '~vb/common/ExcelDownloadPopup';

import CodeMgmtItem from './CodeMgmtItem.vue';

const MODULE_NAME = 'HHP CODE MGMT';
const MODULE_URL = `basis/anysvcmobile/code`;

export default {
    name: 'hhp-code-mgmt',
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
        'code-mgmt-item': CodeMgmtItem,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    props: [],
    computed: {},
    data() {
        return {
            mode: 'search',

            searchStatus: 'done',

            selectedCodeId: 'ALL',
            codeName: '',

            availableParentCodeList: [],

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,

            selectedGridDataKey: 0,

            gridData: [],
            gridColumns: [
                {
                    header: 'Code Category', // PREFIX = '000' 일 때 CODE_NAME
                    name: 'CODE_PARENT_NAME',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Code ID',
                    name: 'CODE_ID',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Code Name',
                    name: 'CODE_NAME',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Note',
                    name: 'CODE_NOTE',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
            gridPageOptions: null,
        };
    },
    created() {
        console.log('Component: hhp-code-mgmt created. ');
        this.initLoad().then(() => {
            return this.search();
        });
    },
    mounted() {
        console.log('Component: hhp-code-mgmt mounted.');
    },
    methods: {
        initLoad() {
            // Fetches List of Code
            return SDLUtil.getRequest(`/${MODULE_URL}/CodeMgt.skp`)
                .then(data => {
                    SDLUtil.showLoadingBar(false);
                    this.availableParentCodeList = data.map(item => {
                        return {
                            CODE_NAME: item[0],
                            CODE_ID: item[1],
                        };
                    });
                });
            
        },
        selectCodeId(ev) {},
        resetSelectedCodeId() {
            this.selectedCodeId = '';
        },

        prepSearchParams(pageNo, exclude = []) {
            if (!pageNo) pageNo = 1;

            let params = {
                page: pageNo,
                codeView: this.selectedCodeId,
                codeName: this.codeName,
            };

            if (exclude.length > 0) {
                exclude.forEach(item => {
                    if (item in params) {
                        delete params[item];
                    }
                });
            }

            console.log(`${MODULE_NAME} SEARCH PARAMS =>>`, params);
            return params;
        },

        search(pageNo) {
            if (!pageNo) pageNo = 1;

            this.mode = 'search';

            const formData = this.prepSearchParams(pageNo);

            SDLUtil.showLoadingBar(true);
            // this.gridData = [];
            // this.searchStatus = 'loading';
            const url = `${SDLUtil.API_URL}/${MODULE_URL}/CodeMgtSearchAjax.skp`;
            return axios
                .post(url, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    console.log('SEARCH RESULT =>> ', resp);
                    // Server에서 결과가 10개 미만일 때 항상 10을 돌려주는 문제를 임시적으로 해결하는 if문
                    if (
                        this.resultCount === 10 &&
                        typeof resp.data.rows !== 'undefined' &&
                        resp.data.rows.length < 10
                    ) {
                        this.resultCount = resp.data.rows.length;
                    } else {
                        this.resultCount = resp.data.count;
                    }
                    this.gridData = resp.data.rows.map(row => {
                        row.CODE_PARENT_ID = row.CODE_IDX.split('-')[0];
                        const found = this.availableParentCodeList.find(
                            parent => parent.CODE_ID === row.CODE_PARENT_ID,
                        );
                        found === null
                            ? (row.CODE_PARENT_NAME = 'UNDEFINED')
                            : (row.CODE_PARENT_NAME = found.CODE_NAME);
                        // if (found === null) {
                        //     row.CODE_PARENT_NAME = 'UNDEFINED';
                        // }
                        // row.CODE_PARENT_NAME = found.CODE_NAME;
                        return row;
                    });

                    console.log('GRID DATA', this.gridData);

                    // this.gridData = Object.assign([], resp.data.rows);

                    // this.searchstatus = 'done';
                    // this.loadingstatus = 'done';

                    this.currentPage = pageNo;
                    this.gridKey += 1; // This will re-render grid
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        gridItemClick(event) {
            console.log('CLICKED');
            if (typeof event.rowKey === 'undefined') return;
            this.selectedGridDataKey = event.rowKey;
            this.switchMode('edit');
        },
        switchMode(mode) {
            this.mode = mode;
        },
        excelDownload() {
            SDLUtil.showLoadingBar(true);

            const data = this.prepSearchParams(this.currentPage);

            return axios
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/code/CodeMgtExcel.skp`, {
                    params: data,
                })
                .then(resp => {
                    console.log(resp);
                    SDLUtil.showLoadingBar(false);
                    //excelWindow.document.write();
                    if (resp.data.EXCEL_FILES.length > 0) {
                        SDLUtil.show(
                            ExcelDownloadPopup,
                            {
                                title: 'Excel Download - Mobile Code Management',
                                excelFiles: resp.data.excelFiles,
                            }, // component params
                            {
                                height: 'auto',
                            }, // dialog params
                        );
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/code/CodeMgmt.vue